import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom } from 'rxjs';

import { ToastrService } from '@shared/services/toastr.service';
import { AuthService, MFA } from '@shared/services/auth.service';
import { MyProfileService } from '@shared/services/my-profile.service';
import { isValidPassword } from '@shared/validators/validators';
import { copyObject, SECOND } from '@shared/utils/data-utils';
import { LabelComponent } from '@shared/components/label/label.component';
import { MfaSetupComponent, MfaValidatedEvent } from '../../auth/login/mfa-setup/mfa-setup.component';
import { AuthApi } from '@shared/services/auth-api.service';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  imports: [FormsModule, NgIf, NgClass, NgbTooltip, TranslatePipe, LabelComponent, MfaSetupComponent],
})
export class AuthenticationComponent implements OnInit, OnDestroy {
  @ViewChild('mfaSetup') mfaSetup?: MfaSetupComponent;

  MFA = MFA;
  lang: string;

  user: any = {};
  userTmp: any = {};
  pswd: any = {};

  editAuth = false;
  editPassword = false;

  hasApiKey = false;
  apiKey = '';

  constructor(
    private auth: AuthService,
    private authApi: AuthApi,
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService,
    private myProfileService: MyProfileService,
  ) {
    this.lang = this.auth.getCurrentLanguage();
  }

  ngOnInit() {
    this.getUser();
  }

  ngOnDestroy() {
    delete this.apiKey;
  }

  onEditAuth() {
    this.editAuth = true;
    this.mfaSetup?.reset(this.user.mfa);
  }

  cancelEditAuth = () => {
    this.editAuth = false;
    this.user.mfa = this.userTmp.mfa;
    this.mfaSetup?.reset(this.userTmp.mfa);
  };

  saveMfa = () => {
    if (this.user.mfa !== MFA.NONE) return;
    this.persistMfa(MFA.NONE);
  };

  onMfaValidated(event: MfaValidatedEvent) {
    this.persistMfa(event.mfa);
  }

  private async persistMfa(mfa: MFA) {
    try {
      await firstValueFrom(this.myProfileService.setMfa(mfa));
      this.auth.updateUser({ mfa });
      await this.auth.init();
      this.user.mfa = mfa;
      this.userTmp = copyObject(this.user);
      this.toastr.success('SuccfChang');
      this.editAuth = false;
    } catch {
      this.toastr.error('Error');
    }
  }

  showKey() {
    this.myProfileService.getApiKey().subscribe((apiKey) => {
      this.apiKey = apiKey;
      setTimeout(() => this.apiKey = this.redactedApiKey, 10*SECOND);
    });
  }

  resetPassword() {
    if (!isValidPassword(this.pswd.password)) {
      this.toastr.error('MotDePasseFort');
      return;
    }
    if (this.pswd.password !== this.pswd.password2) {
      this.toastr.error('MotDePasseNeCorrespondentPas');
      return;
    }
    this.authApi.changePassword({ password: this.pswd.ancienPassword, newPassword: this.pswd.password })
      .subscribe(() => {
        this.pswd = {};
        this.toastr.success('PasswordChanged');
        this.editPassword = false;
      });
  }

  cancelEditPassword() {
    this.editPassword = false;
    this.pswd = {
      ancienPassword: '',
      password: '',
      password2: '',
    };
  }

  public disabledPasswordButton = (): boolean => {
    return (
      this.pswd.password !== this.pswd.password2 ||
      !this.pswd.ancienPassword ||
      !this.pswd.password ||
      !this.checkPasswordPattern() ||
      !this.pswd.password2
    );
  };

  protected checkPasswordPattern(): boolean {
    return isValidPassword(this.pswd.password);
  }

  private readonly redactedApiKey = '●●●●●●●';

  private getUser() {
    this.myProfileService.getProfile().subscribe((user) => {
      this.user = {
        email: user.email,
        lastName: user.lastName,
        firstName: user.firstName,
        mfa: user.mfa,
        lang: user.lang,
      };
      this.userTmp = copyObject(this.user);
      this.hasApiKey = user.hasApiKey;
      this.apiKey = user.hasApiKey ? this.redactedApiKey : '';
    });
  }
}
